import { type ComponentPropsWithoutRef, type ReactNode } from 'react';
import cx from 'clsx';
import { FormattedMessage } from 'react-intl';
import { QontoLogo } from '@repo/design-system-kit/components/qonto-logo/qonto-logo';
import { DougsPoweredByQontoLogo } from '@repo/design-system-kit/components/co-branded-logos/dougs/dougs-powered-by-qonto';
import { useEmberService } from '@qonto/react-migration-toolkit/react/hooks';
import { DropdownLanguage } from 'register-partners-js/react/components/dropdown-language';
import { useIsCobrandedDougs } from 'register-partners-js/react/hooks/use-is-cobranded-dougs';
import styles from './topbar.module.css';

export function Topbar({ className, ...props }: ComponentPropsWithoutRef<'div'>): ReactNode {
  const session = useEmberService('session');
  const { isAuthenticated } = session;

  const handleSignout = (): void => {
    void session.invalidate();
  };

  const isCobrandedDougs = useIsCobrandedDougs();

  return (
    <div className={cx(styles.signupTopbar, className)} {...props}>
      <div className={styles.logo} data-test-register-signup-topbar-logo>
        {isCobrandedDougs ? (
          <DougsPoweredByQontoLogo className={styles.coBrandedLogo} />
        ) : (
          <QontoLogo />
        )}
      </div>
      <div className={styles.right}>
        {isAuthenticated ? (
          <button
            className="btn btn--tertiary mr-16"
            data-test-topbar-signout-btn
            onClick={handleSignout}
            type="button"
          >
            <FormattedMessage id="generic.sign-out.cta" />
          </button>
        ) : null}
        <DropdownLanguage className="hide-on-mobile" data-test-register-signup-topbar-language-dd />
      </div>
    </div>
  );
}
